module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper",
    class: [_vm.settings.Language.items[_vm.settings.Language.selected].name, _vm.setDeviceClass],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "aside-overlay",
    class: [{
      active: _vm.settingsActive
    }, {
      active: _vm.referenceconditions
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "splash",
    class: {
      active: _vm.splashActive
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "aside-wrapper aside-wrapper--info",
    class: {
      active: _vm.referenceconditions
    }
  }, [_c('div', {
    staticClass: "aside__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('t-reference-conditions-explanation')))]), _vm._v(" "), _c('a', {
    staticClass: "aside__close",
    attrs: {
      "href": "#",
      "title": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-close"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "aside__body"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('t-reference-conditions-explanation-text')) + "\n\t\t\t"), _c('table', {
    staticClass: "reference-conditions-table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('t-unit')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('t-pressure')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('t-temperature')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('t-Relativehumidity')))])]), _vm._v(" "), _vm._l((_vm.referenceConditionsData), function(item, index) {
    return _c('tr', {
      key: ('reftab' + index)
    }, [_c('td', {
      domProps: {
        "innerHTML": _vm._s(item.unit)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.pressure)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.temperature)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.Relativehumidity)
      }
    })])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "aside-wrapper aside-wrapper--settings",
    class: {
      active: _vm.settingsActive
    }
  }, [_c('div', {
    staticClass: "aside__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('t-settings')))]), _vm._v(" "), _c('a', {
    staticClass: "aside__close",
    attrs: {
      "href": "#",
      "title": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(false)
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-close"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "aside__body"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.updateLanguage))]), _vm._v(" "), _c('inputdropdown', {
    attrs: {
      "item": _vm.settings.Language
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.CompressedAirFlow
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.Pressure
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.Temperature
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.CoolingWaterflow
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.CoolingWaterInput
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.GlycolType
    }
  }), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.GlycolConcentrationInCoolingWater,
      "unit": '%',
      "selectedindex": _vm.unitlist.selected
    }
  }), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(true)
      }
    }
  }, [_c('svg', {
    staticClass: "icon-warning",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#warning2"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-reference-conditions')))]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.ReferenceTemperature,
      "unit": _vm.settings.Temperature.items[_vm.settings.Temperature.selected].name,
      "selectedindex": _vm.unitlist.selected
    }
  }), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.ReferencePressure,
      "unit": _vm.settings.Pressure.items[_vm.settings.Pressure.selected].name,
      "selectedindex": _vm.unitlist.selected
    }
  }), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.ReferenceRelativeHumidity,
      "unit": '%',
      "selectedindex": _vm.unitlist.selected
    }
  })], 1)]), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "header__inner"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "header__title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('t-hd-coolers-calculation-tool')))])]), _vm._v(" "), _c('div', {
    staticClass: "header__btn"
  }, [_c('a', {
    staticClass: "header__btn--info btn--toggle ",
    attrs: {
      "href": "#",
      "data-aside-target": "distribution"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendReport()
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-info"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "header__btn--settings",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(false)
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-settings"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      active: _vm.isContentActive
    }
  }, [_c('div', {
    staticClass: "content-tabs"
  }, [_c('div', {
    staticClass: "setting__option tabs",
    attrs: {
      "id": "air-flow"
    }
  }, _vm._l((_vm.unitlist.items), function(item, index) {
    return _c('button', {
      key: item.id,
      staticClass: "tab-btn",
      class: {
        active: (_vm.unitlist.selected === index)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.unitlistClicked(index)
        }
      }
    }, [_vm._v(_vm._s(item.Model))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-settings"
  }, [_c('div', {
    staticClass: "content-settings__box content-settings__box--left"
  }, [_c('div', {
    staticClass: "content-settings__box--top"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#air"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-inlet-compressed-air')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.inletCompressedAir), function(item, index) {
    return _c('inputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "Limitations": _vm.Limitations,
        "inputType": 'Fluid',
        "plugindataInput": _vm.plugindataInput
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-settings__box--bottom"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#water"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-cooling-water-input')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.coolingWateInput), function(item, index) {
    return _c('inputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "Limitations": _vm.Limitations,
        "inputType": 'Coolant',
        "plugindataInput": _vm.plugindataInput
      }
    })
  })], 2)]), _vm._v(" "), _c('bg-image', {
    attrs: {
      "unitlist": _vm.unitlist
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-settings__box content-settings__box--right content-settings__box--result"
  }, [_c('div', {
    staticClass: "content-settings__box--top content-settings__box--top-result"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#air"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-outlet-compressed-air')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.outletCompressedAir), function(item, index) {
    return _c('outputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "inputType": 'Fluid'
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-settings__box--bottom"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#water"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-cooling-water-output')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.coolingWaterOuput), function(item, index) {
    return _c('outputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "inputType": 'Coolant'
      }
    })
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash__infobox"
  }, [_c('h3', {
    staticClass: "splash__title"
  }, [_vm._v("ATLAS COPCO\n\t\t\t\t"), _c('br'), _vm._v("HD Coolers Calculation Tool")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header__logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/css/logo.svg"),
      "alt": "Atlas Copco logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-485b4952","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 233
// module chunks = 0